import { AfterViewInit, Component, ElementRef, ViewChild } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { takeUntil } from "rxjs/operators";
import { UnsubscribeComponent } from "../../generals/Components";
import { PageEditor } from "../../interfaces/interfaces";
import { ApiService } from "../../services/api.service";

@Component({
    selector: 'app-pageeditor',
    templateUrl: './pageeditor.component.html'
})
export class PageEditorComponent extends UnsubscribeComponent implements AfterViewInit {
    pageId: number = null;
    pageEditorFormGroup: FormGroup = null;
    dataLoading = false;
    loading = false;
    @ViewChild('input') input: ElementRef<HTMLInputElement>;

    init(): void {
        this.initPageEditorFormGroup();
        const pageId: string|null = this.activatedRoute.snapshot.paramMap.get('id');
        if (pageId !== null) {
          this.pageId = parseInt(pageId, 10);
        }
        this.loadPage();
    }

    initPageEditorFormGroup(): void {
        this.pageEditorFormGroup = new FormGroup({
            title: new FormControl('', [Validators.required]),
            slug: new FormControl('', [Validators.required]),
            content: new FormControl('', [Validators.required])
        })
    }

    loadPage(): void {
        if (this.pageId !== null) {
            this.dataLoading = true;
            this.apiService.getPage(this.pageId).pipe(takeUntil(this.unsubscribe)).subscribe(({pageEditor}) => {
                this.fillPageEditorForm(pageEditor);
                this.dataLoading = false;
            });
        }
    }

    fillPageEditorForm(pageEditor: PageEditor): void {
        this.pageEditorFormGroup.get('title').setValue(pageEditor.title);
        this.pageEditorFormGroup.get('slug').setValue(pageEditor.slug);
        this.pageEditorFormGroup.get('content').setValue(pageEditor.content);
    }

    save(): void {
        if (this.pageEditorFormGroup.invalid) {
            return;
        }
        this.loading = true;
        const pageEditorFormValue: any = this.pageEditorFormGroup.getRawValue();
        if (this.pageId === null) {
            this.apiService.createPage(pageEditorFormValue).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Oldal hozzáadása',
                  detail: 'Sikeres hozzáadás'
                });
                this.back();
            }).add(() => {
                this.loading = false;
            });
        } else {
            this.apiService.savePage(this.pageId, pageEditorFormValue).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
                this.messageService.add({
                  severity: 'success',
                  summary: 'Oldal szerkesztése',
                  detail: 'Sikeres szerkesztése'
                });
                this.back();
            }).add(() => {
                this.loading = false;
            });
        }
    }

    back(): void {
        this.router.navigate(['pages']);
    }

    ngAfterViewInit(): void {
        this.input.nativeElement.focus();
    }

    constructor(
        private apiService: ApiService,
        private router: Router,
        private messageService: MessageService,
        private activatedRoute: ActivatedRoute
    ) {
        super();
        this.init();
    }
}